import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { RoleService } from 'src/app/private/services/role.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-role',
  imports: [SharedModule],
  templateUrl: './delete-role.component.html',
  styleUrl: './delete-role.component.scss'
})
export class DeleteRoleComponent {
  @Input() clientId!: string;
  @Input() roleDataToEdit: any = null; // To hold the role data to be deleted

   @Output() close = new EventEmitter<void>();
  roleName: string = ''; // Campus name to be displayed in the confirmation dialog
  @Output() reload = new EventEmitter<void>(); // Event emitter to notify parent component for reloading data

  constructor(
    private roleService: RoleService,
    private messageService: MessageService
  ) {
   
  }

  ngOnInit() {
     console.log("Role Data to Edit:", this.roleDataToEdit);
    // Initialize the campus name with the name of the campus to be deleted
    this.roleName = this.roleDataToEdit?.role_name
  }

  isLoading: boolean = false; // Loading state for the form submission
  handleCloseDialog() {
    this.close.emit();
  }


  handleDeleteCampus() {
    this.isLoading = true; // Set loading state to true
    const payload = {
      clientId: this.clientId, // Use the client ID passed from the parent component
      role_id : this.roleDataToEdit.role_id
    };
    this.roleService.deleteRole(payload).subscribe(
      (response) => {
        this.isLoading = false; // Reset loading state
        this.close.emit(); // Emit close event to notify parent component
        this.reload.emit(); // Emit reload event to notify parent component for reloading data
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Campus deleted successfully!'
        });
      },
      (error) => {
        console.error('Error deleting campus:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete campus!'
        });

        this.isLoading = false; // Reset loading state on error
      }
    );
  }

}
